import clsx from 'clsx'
import { ReactElement } from 'react'

import { Text } from '../../../common/designs'
import type { ProcessAnalysisConfig } from '../types'
import TrackedProcessCard from './TrackedProcessCard'
import { getProcessOrCategoryMaxFourGridClass } from './utils'

interface Props {
  category: string
  processes: ProcessAnalysisConfig[]
  totalAppUsageTrendMapper: {
    [key: string]: number
  }
  lastItem?: ReactElement | null
}

const ProcessSection = ({ category, processes, totalAppUsageTrendMapper, lastItem }: Props) => {
  const cellCount = processes.length + (lastItem ? 1 : 0)
  const isSingleCard = cellCount === 1
  const spansFullCategoryRow = cellCount >= 4

  return (
    <section
      className={clsx(
        'flex h-full min-w-0 flex-col overflow-hidden rounded-lg border border-slate-200/90 bg-white shadow-sm',
        spansFullCategoryRow && 'col-span-full',
      )}
    >
      <header className='border-b border-slate-200/90 bg-gradient-to-r from-slate-100/95 via-primary-50/40 to-slate-50/90 px-3 py-2.5 sm:px-4 sm:py-3'>
        <div className='flex items-start justify-between gap-2'>
          <Text size='l' weight={700} className='min-w-0 break-words leading-snug text-slate-900'>
            {category}
          </Text>
          <span className='shrink-0 whitespace-nowrap rounded border border-slate-200/80 bg-white/90 px-2 py-0.5 text-[10px] font-medium tabular-nums leading-tight text-slate-600 sm:text-[11px]'>
            {processes.length} {processes.length === 1 ? 'process' : 'processes'}
          </span>
        </div>
      </header>
      <div className='flex flex-1 flex-col bg-white/95 p-3 sm:p-4'>
        <div
          className={clsx(
            'grid w-full min-w-0',
            isSingleCard ? 'grid-cols-1' : getProcessOrCategoryMaxFourGridClass(),
          )}
        >
          {[
            ...processes.map((process) => (
              <TrackedProcessCard
                key={process.id}
                process={process}
                totalAppUsageTrendMapper={totalAppUsageTrendMapper}
              />
            )),
            lastItem ? lastItem : null,
          ]}
        </div>
      </div>
    </section>
  )
}

export default ProcessSection

